var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "base-top-menuNav base-flex" },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "base-menuNav base-flex-between",
          attrs: { role: "navigation", tabindex: "0" },
        },
        [
          _c(
            "div",
            {
              staticClass: "base-menu base-flex",
              attrs: { role: "menu", tabindex: "0" },
            },
            _vm._l(_vm.$store.getters.menus, function (item) {
              return _c(
                "div",
                {
                  key: item.title,
                  staticClass: "menuitem",
                  class: _vm.className(item),
                  attrs: { role: "menuitem", tabindex: "0" },
                  on: {
                    click: function ($event) {
                      return _vm.handleChangeMenu(item)
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleChangeMenu(item)
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$tran(item.Ename)))])]
              )
            }),
            0
          ),
          _c(
            "div",
            {
              staticClass: "base-user base-flex",
              attrs: {
                "aria-label": _vm.$tran("Personal Center"),
                tabindex: "0",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "user-logout base-flex",
                  attrs: {
                    role: "button",
                    "aria-label": _vm.$tran("Exit"),
                    tabindex: "0",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleLogout()
                    },
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleLogout()
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: { src: require("@/assets/img/logout.png"), alt: "" },
                  }),
                  _c("span", { staticClass: "base-bText14" }, [
                    _vm._v(_vm._s(_vm.$tran("Exit"))),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "user-center",
                  attrs: {
                    role: "button",
                    "aria-label": _vm.$tran("Personal center image button"),
                    tabindex: "0",
                  },
                  on: {
                    click: _vm.showDialog,
                    keypress: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.showDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/img/userExample.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
      _c(
        "cus-dialog",
        {
          staticClass: "exportDialog",
          attrs: {
            title: _vm.$tran("Settings"),
            visible: _vm.userProfile,
            close: _vm.closeUserProfile,
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("div", { staticClass: "languageSelect base-flex" }, [
              _c(
                "div",
                { staticClass: "base-formItem" },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$tran("Language")))]),
                  _c(
                    "el-select",
                    {
                      ref: "menuSelect",
                      attrs: {
                        placeholder: _vm.$tran("Select the x", "Language"),
                      },
                      on: { change: _vm.changeLanguage },
                      model: {
                        value: _vm.curLanguage,
                        callback: function ($$v) {
                          _vm.curLanguage = $$v
                        },
                        expression: "curLanguage",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          value: "zh",
                          label: _vm.$tran("Simplified Chinese"),
                        },
                      }),
                      _c("el-option", {
                        attrs: { value: "en", label: _vm.$tran("English") },
                      }),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: {
                              value: "zhHant",
                              label: _vm.$tran("Traditional Chinese"),
                            },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: { value: "fr", label: _vm.$tran("French") },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: { value: "de", label: _vm.$tran("German") },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: { value: "it", label: _vm.$tran("Italian") },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: { value: "es", label: _vm.$tran("Spanish") },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: {
                              value: "ja",
                              label: _vm.$tran("Japanese"),
                            },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: { value: "th", label: _vm.$tran("Thai") },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: {
                              value: "ukUa",
                              label: _vm.$tran("Ukrainian"),
                            },
                          })
                        : _vm._e(),
                      _vm.setLangs
                        ? _c("el-option", {
                            attrs: {
                              value: "ruRu",
                              label: _vm.$tran("Russian"),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "userInfoForm" }, [
              _c("div", { staticClass: "base-flex" }, [
                _c(
                  "div",
                  { staticClass: "avatar base-formItem base-flex-grow1" },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$tran("Profile Picture")))]),
                    _c("img", {
                      attrs: {
                        src: require("@/assets/img/userExample.png"),
                        alt: "",
                      },
                    }),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "base-formItem" },
                  [
                    _c("label", { attrs: { for: "role" } }, [
                      _vm._v(_vm._s(_vm.$tran("Role"))),
                    ]),
                    _c("cus-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.curRoleName,
                        size: "big",
                        placeholder: _vm.$tran("Please Enter your x", "Role"),
                        id: "role",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "userInfo-disabled base-flex" }, [
                _c(
                  "div",
                  { staticClass: "base-formItem" },
                  [
                    _c("label", { attrs: { for: "username" } }, [
                      _vm._v(_vm._s(_vm.$tran("Username"))),
                    ]),
                    _c("cus-input", {
                      attrs: {
                        disabled: "",
                        value: _vm.$store.getters.user.username,
                        size: "big",
                        placeholder: _vm.$tran("Enter your username"),
                        id: "username",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "base-formItem" },
                  [
                    _c("label", { attrs: { for: "nickname" } }, [
                      _vm._v(_vm._s(_vm.$tran("Full Name"))),
                    ]),
                    _c("cus-input", {
                      attrs: {
                        size: "big",
                        placeholder: _vm.$tran("Enter your full name"),
                        id: "nickname",
                      },
                      model: {
                        value: _vm.userInfo.nickname,
                        callback: function ($$v) {
                          _vm.$set(_vm.userInfo, "nickname", $$v)
                        },
                        expression: "userInfo.nickname",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "changeFormItem" }, [
                _c(
                  "span",
                  {
                    attrs: { tabindex: "0" },
                    on: { click: _vm.updateUserInfo },
                  },
                  [_vm._v(_vm._s(_vm.$tran("Edit Profile")))]
                ),
              ]),
              _c("div", { staticClass: "base-flex" }, [
                _c(
                  "div",
                  { staticClass: "base-formItem" },
                  [
                    _c("label", { attrs: { for: "password" } }, [
                      _vm._v(_vm._s(_vm.$tran("Old Password"))),
                    ]),
                    _c(
                      "cus-input",
                      {
                        attrs: {
                          size: "big",
                          id: "password",
                          password: "",
                          type: _vm.oldpasswordVisable ? "password" : "text",
                        },
                        model: {
                          value: _vm.userPassword.password,
                          callback: function ($$v) {
                            _vm.$set(_vm.userPassword, "password", $$v)
                          },
                          expression: "userPassword.password",
                        },
                      },
                      [
                        _c("i", {
                          class: _vm.oldpasswordVisable
                            ? "el-icon-lock"
                            : "el-icon-unlock",
                          attrs: { slot: "suffix" },
                          on: {
                            click: function ($event) {
                              _vm.oldpasswordVisable = !_vm.oldpasswordVisable
                            },
                          },
                          slot: "suffix",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "userInfo base-flex",
                  staticStyle: {
                    "margin-top": "6px",
                    "align-items": "flex-start",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "base-formItem",
                      staticStyle: { "font-size": "12px", color: "#999" },
                    },
                    [
                      _c("label", { attrs: { for: "newPassword" } }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$tran("Enter the original password")) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "userInfo base-flex",
                  staticStyle: { "margin-top": "10px" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "base-formItem" },
                    [
                      _c("label", { attrs: { for: "newPassword" } }, [
                        _vm._v(_vm._s(_vm.$tran("New Password"))),
                      ]),
                      _c(
                        "cus-input",
                        {
                          attrs: {
                            size: "big",
                            id: "newPassword",
                            password: "",
                            type: _vm.passwordVisable ? "password" : "text",
                          },
                          model: {
                            value: _vm.userPassword.newPassword,
                            callback: function ($$v) {
                              _vm.$set(_vm.userPassword, "newPassword", $$v)
                            },
                            expression: "userPassword.newPassword",
                          },
                        },
                        [
                          _c("i", {
                            class: _vm.passwordVisable
                              ? "el-icon-lock"
                              : "el-icon-unlock",
                            attrs: { slot: "suffix" },
                            on: {
                              click: function ($event) {
                                _vm.passwordVisable = !_vm.passwordVisable
                              },
                            },
                            slot: "suffix",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "base-formItem" },
                    [
                      _c("label", { attrs: { for: "newConfirmPassword" } }, [
                        _vm._v(_vm._s(_vm.$tran("Confirm Password"))),
                      ]),
                      _c(
                        "cus-input",
                        {
                          attrs: {
                            size: "big",
                            id: "newConfirmPassword",
                            password: "",
                            type: _vm.passwordVisable2 ? "password" : "text",
                          },
                          model: {
                            value: _vm.userPassword.newConfirmPassword,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userPassword,
                                "newConfirmPassword",
                                $$v
                              )
                            },
                            expression: "userPassword.newConfirmPassword",
                          },
                        },
                        [
                          _c("i", {
                            class: _vm.passwordVisable2
                              ? "el-icon-lock"
                              : "el-icon-unlock",
                            attrs: { slot: "suffix" },
                            on: {
                              click: function ($event) {
                                _vm.passwordVisable2 = !_vm.passwordVisable2
                              },
                            },
                            slot: "suffix",
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "userInfo base-flex",
                  staticStyle: {
                    "margin-top": "6px",
                    "align-items": "flex-start",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "base-formItem",
                      staticStyle: { "font-size": "12px", color: "#999" },
                    },
                    [
                      _c("label", { attrs: { for: "newPassword" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tran(
                              "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "base-formItem",
                      staticStyle: { "font-size": "12px", color: "#999" },
                    },
                    [
                      _c("label", { attrs: { for: "newPassword" } }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$tran(
                              "Enter the new password again。Two times of new password input is same"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ]
              ),
              _c("div", { staticClass: "changeFormItem" }, [
                _c(
                  "span",
                  {
                    attrs: { tabindex: "0" },
                    on: { click: _vm.updateUserPassword },
                  },
                  [_vm._v(_vm._s(_vm.$tran("Change Password")))]
                ),
              ]),
            ]),
            _c("div", { staticClass: "userHelpInfo" }, [
              _c(
                "div",
                { staticClass: "base-flex-center" },
                _vm._l(_vm.userHelpArr, function (i) {
                  return _c(
                    "div",
                    { key: i.link, staticClass: "userHelpItem" },
                    [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.skipLink(i)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$tran(i.text)))]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "version", attrs: { id: "appVersion" } }, [
            _vm._v(_vm._s(_vm.appVersion)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "base-logo" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/logo.png"), alt: "logo" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }